"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapView = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const MapView = ({ style: styleOverrides = {}, size, className = "", }) => {
    const cssStyle = size !== null && size !== void 0 ? size : "100%";
    const coreStyle = {
        display: "inlineBlock",
        width: cssStyle,
        height: cssStyle,
    };
    const style = Object.assign(Object.assign({}, coreStyle), styleOverrides);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ id: "map-view", viewBox: "0 0 32 32", className: `${className}`, style: style }, { children: (0, jsx_runtime_1.jsx)("g", Object.assign({ id: "map-view", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M16 0C11.894-.003 8.069 2.025 5.867 5.373a11.125 11.125 0 0 0-1.866 6.197c0 1.799.423 3.499 1.175 5.006l-.029-.065c.237.473.51.928.815 1.362l9.63 13.917a.496.496 0 0 0 .811.002l.001-.002 9.554-13.829c.354-.49.67-1.005.943-1.542 1.711-3.585 1.41-7.764-.794-11.089C23.899 2.007 20.09-.002 16 0z" }) })) })));
};
exports.MapView = MapView;
